import { ANIMATE_DELAY, ANIMATED_STYLE } from "src/libs/interfaces/animated"; 
import { LINKS_DESIGN_TYPE } from "../interfaces";
import { getID } from "src/libs/utilities";

export default function contacts(): any[] {
     return [ 
        { 
            id: getID("contacts"),
            animated: ANIMATED_STYLE.FADE_IN_RIGHT,
            animated_delay: ANIMATE_DELAY.WATERFALL,
            design_type: LINKS_DESIGN_TYPE.SQUARE,
            items: [
              {
                id: getID("contact"), 
                url: "",
                "sc": "telegram", 
                "cf": { "contactFormSectionID": "-1" }
              },
              {
                id: getID("contact"), 
                "url": "",
                "sc": "vk", 
                "cf": { "contactFormSectionID": "-1" }
              },
              {
                id: getID("contact"), 
                "url": "",
                "sc": "odnoklassniki", 
                "cf": { "contactFormSectionID": "-1" }
              }, 
              {
                id: getID("contact"), 
                "url": "",
                "sc": "dzen", 
                "cf": { "contactFormSectionID": "-1" }
              },
              {
                id: getID("contact"), 
                "url": "",
                "sc": "rutube", 
                "cf": { "contactFormSectionID": "-1" }
              },
              {
                id: getID("contact"), 
                "url": "",
                "sc": "max", 
                "cf": { "contactFormSectionID": "-1" }
              },
            ],
            defaultTitle: "Большие квадратные кнопки"
        },
        { 
            id: getID("contacts"),
            animated: ANIMATED_STYLE.FADE_IN_RIGHT,
            animated_delay: ANIMATE_DELAY.WATERFALL,
            design_type: LINKS_DESIGN_TYPE.SMALL_OUTLINE_BW,
            items: [
              {
                id: getID("contact"), 
                url: "",
                "sc": "telegram", 
                "cf": { "contactFormSectionID": "-1" },
                label: "Связаться",
              },
              {
                id: getID("contact"), 
                "url": "",
                "sc": "vk", 
                "cf": { "contactFormSectionID": "-1" },
                label: "Связаться",
              },
              {
                id: getID("contact"), 
                "url": "",
                "sc": "odnoklassniki", 
                "cf": { "contactFormSectionID": "-1" },
                label: "Связаться",
              }, 
              {
                id: getID("contact"), 
                "url": "",
                "sc": "dzen", 
                "cf": { "contactFormSectionID": "-1" },
                label: "Связаться",
              },
              {
                id: getID("contact"), 
                "url": "",
                "sc": "rutube", 
                "cf": { "contactFormSectionID": "-1" },
                label: "Связаться",
              },
              {
                id: getID("contact"), 
                "url": "",
                "sc": "max", 
                "cf": { "contactFormSectionID": "-1" },
                label: "Связаться",
              },
            ],
            defaultTitle: "Маленькие минималистические чб-кнопки"
        },
        { 
            id: getID("contacts"),
            animated: ANIMATED_STYLE.FADE_IN_RIGHT,
            animated_delay: ANIMATE_DELAY.WATERFALL,
            design_type: LINKS_DESIGN_TYPE.SMALL_MINIMAL,
            items: [
              {
                id: getID("contact"), 
                url: "",
                "sc": "telegram", 
                "cf": { "contactFormSectionID": "-1" }
              },
              {
                id: getID("contact"), 
                "url": "",
                "sc": "vk", 
                "cf": { "contactFormSectionID": "-1" }
              },
              {
                id: getID("contact"), 
                "url": "",
                "sc": "odnoklassniki", 
                "cf": { "contactFormSectionID": "-1" }
              }, 
              {
                id: getID("contact"), 
                "url": "",
                "sc": "dzen", 
                "cf": { "contactFormSectionID": "-1" }
              },
              {
                id: getID("contact"), 
                "url": "",
                "sc": "rutube", 
                "cf": { "contactFormSectionID": "-1" }
              },
              {
                id: getID("contact"), 
                "url": "",
                "sc": "max", 
                "cf": { "contactFormSectionID": "-1" }
              },
            ],
            defaultTitle: "Маленькие минималистические кнопки"
        },
        { 
            id: getID("contacts"),
            animated: ANIMATED_STYLE.FADE_IN_RIGHT,
            animated_delay: ANIMATE_DELAY.WATERFALL,
            design_type: LINKS_DESIGN_TYPE.ROUND_OUTLINE_BW,
            border_width: 2, 
            items: [
              {
                id: getID("contact"), 
                url: "",
                "sc": "telegram", 
                "cf": { "contactFormSectionID": "-1" }
              },
              {
                id: getID("contact"), 
                "url": "",
                "sc": "vk", 
                "cf": { "contactFormSectionID": "-1" }
              },
              {
                id: getID("contact"), 
                "url": "",
                "sc": "odnoklassniki", 
                "cf": { "contactFormSectionID": "-1" }
              }, 
              {
                id: getID("contact"), 
                "url": "",
                "sc": "dzen", 
                "cf": { "contactFormSectionID": "-1" }
              },
              {
                id: getID("contact"), 
                "url": "",
                "sc": "rutube", 
                "cf": { "contactFormSectionID": "-1" }
              },
              {
                id: getID("contact"), 
                "url": "",
                "sc": "max", 
                "cf": { "contactFormSectionID": "-1" }
              },
            ],
            defaultTitle: "Круглые чб-кнопки с обводкой"
        },
        { 
            id: getID("contacts"),
            animated: ANIMATED_STYLE.FADE_IN_RIGHT,
            animated_delay: ANIMATE_DELAY.WATERFALL,
            design_type: LINKS_DESIGN_TYPE.OUTLINE_BW,
            border_width: 2,
            size: 55,
            items: [
              {
                id: getID("contact"), 
                url: "",
                "sc": "telegram", 
                "cf": { "contactFormSectionID": "-1" }
              },
              {
                id: getID("contact"), 
                "url": "",
                "sc": "vk", 
                "cf": { "contactFormSectionID": "-1" }
              },
              {
                id: getID("contact"), 
                "url": "",
                "sc": "odnoklassniki", 
                "cf": { "contactFormSectionID": "-1" }
              }, 
              {
                id: getID("contact"), 
                "url": "",
                "sc": "dzen", 
                "cf": { "contactFormSectionID": "-1" }
              },
              {
                id: getID("contact"), 
                "url": "",
                "sc": "rutube", 
                "cf": { "contactFormSectionID": "-1" }
              },
              {
                id: getID("contact"), 
                "url": "",
                "sc": "max", 
                "cf": { "contactFormSectionID": "-1" }
              },
            ],
            defaultTitle: "Огромные квадратные чб-кнопки с обводкой"
        },
        { 
            id: getID("contacts"),
            animated: ANIMATED_STYLE.FADE_IN_RIGHT,
            animated_delay: ANIMATE_DELAY.WATERFALL,
            design_type: LINKS_DESIGN_TYPE.SMALL, 
            items: [
              {
                id: getID("contact"), 
                url: "",
                "sc": "telegram", 
                "cf": { "contactFormSectionID": "-1" }
              },
              {
                id: getID("contact"), 
                "url": "",
                "sc": "vk", 
                "cf": { "contactFormSectionID": "-1" }
              },
              {
                id: getID("contact"), 
                "url": "",
                "sc": "odnoklassniki", 
                "cf": { "contactFormSectionID": "-1" }
              }, 
              {
                id: getID("contact"), 
                "url": "",
                "sc": "dzen", 
                "cf": { "contactFormSectionID": "-1" }
              },
              {
                id: getID("contact"), 
                "url": "",
                "sc": "rutube", 
                "cf": { "contactFormSectionID": "-1" }
              },
              {
                id: getID("contact"), 
                "url": "",
                "sc": "max", 
                "cf": { "contactFormSectionID": "-1" }
              },
            ],
            defaultTitle: "Маленькие квадратные кнопки"
        },
     ]
}